export const COURSES_QUERY_PARAMS = {
  SEARCH: 'q',
  AVAILABLE_FOR: 'availableFor',
} as const;

export const AVAILABLE_FOR_OPTIONS = [
  { value: 'legal', label: 'Юрлица' },
  { value: 'ip', label: 'ИП' },
  { value: 'individual', label: 'Физлица' },
] as const;

export type AvailableForValue = typeof AVAILABLE_FOR_OPTIONS[number]['value'];
